// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__cfvnW","detailsBorder":"styles_detailsBorder__3r3Fs"};